import { IButtonStyles, ICommandBarStyles, IContextualMenuItemStyles, concatStyleSets, getTheme, memoizeFunction } from "@fluentui/react";
const theme = getTheme();

export const itemStyles: Partial<IContextualMenuItemStyles> = {
  label: { fontSize: 18 },
  icon: { color: theme.palette.white },
  iconHovered: { color: theme.palette.black },
};

export const getCommandBarButtonStyles = memoizeFunction(
  (originalStyles: IButtonStyles | undefined): Partial<IContextualMenuItemStyles> => {
    if (!originalStyles) {
      return itemStyles;
    }
    originalStyles = {
      root: { backgroundColor: "transparent" },
      flexContainer: { display: "flex", flexDirection: "column", backgroundColor: "transparent" },
      textContainer: { flexGrow: "inherit", color: theme.palette.white },
      labelHovered: { color: theme.palette.black },
    };
    return concatStyleSets(originalStyles, itemStyles);
  },
);

export const CommandBarStyles: Partial<ICommandBarStyles> = {
  root: {
    backgroundColor: "transparent",
    padding: "0px",
    height: "60px",
    "button:hover, div:hover, i:hover": {
      backgroundColor: "rgba(50, 49, 48, 0.99) !important",
      color: "white !important",
      "& i": {
        color: "white !important",
      }
    },
    "button:focus-visible": {
      outline: "2px solid #fff",
      outlineOffset: -2,
    }
  },
};
